module.exports = __webpack_public_path__ + "img/2.2.7e9491e9.png";